<template>
    <section class="layout">
        <template>
            <div class="relative">
                <QuizHeader
                    :title="title"
                    :currentQuizIndex="playingCurrentQuestionIndex"
                    :questionCount="questionCount"
                />
                <div class="header-tool flex items-center absolute h-full">
                    <user-counter class="pr-4" :counter="currentPlayers" />
                    <bg-music-mute-btn
                        v-if="this.confirmedPlaySound && !this.allMuted"
                        style="position: unset"
                        class="pr-4"
                        :is-muted="isMuted"
                        :is-spotify="isSoundQuestion"
                    ></bg-music-mute-btn>
                </div>
            </div>
        </template>
        <template v-if="type == 'poll'">
            <div v-if="type == 'quiz'" class="header">
                <p class="text-white font-garage text-2xl mt-4 pr-4 text-right">
                    {{ playingCurrentQuestionIndex + 1 }}/{{ questionCount }}
                </p>
                <h1
                    :class="{
                        'uppercase text-center mt-4 mb-0 font-garage text-3xl text-white': true,
                        'block md:hidden': type == 'poll',
                        'md:mb-12': type == 'quiz'
                    }"
                >
                    {{ title }}
                </h1>
                <h1
                    v-if="type == 'poll'"
                    class="hidden md:block uppercase text-left mt-4 mb-0 font-garage text-3xl text-white px-4"
                >
                    {{ title }}
                </h1>
            </div>
        </template>
        <div class="content mx-0 pt-3">
            <div v-if="type == 'poll'">
                <PollResult
                    :image-answer="imageAnswer()"
                    user-type="master"
                    :answers.sync="question.answers"
                    :title="question.title"
                ></PollResult>
            </div>
            <div class="md:h-full" v-if="type == 'quiz'">
                <QuizResult
                    v-if="startLiveSection"
                    :results.sync="quizResults"
                    :answers="question.answers"
                    user-type="master"
                    :show-correct-answer.sync="isShowCorrectAnswer"
                    :title="question.title"
                    :question-type="question.question_type"
                    :question-image="question.image"
                    :userCount="userCount.toString()"
                    :playerCount="playerCount.toString()"
                    :currentQuizIndex="playingCurrentQuestionIndex"
                    :questionCount="questionCount"
                    :correctCount="correctCount"
                    :wrongCount="wrongCount"
                    :top3="top3"
                    :setting="setting.masterResultSetting"
                ></QuizResult>
            </div>
        </div>
        <div v-if="type == 'poll'" class="footer" :style="{ paddingBottom: type == 'poll' ? '15px' : false }">
            <div class="block md:hidden">
                <div class="flex items-center justify-center mb-6">
                    <span class="text-white text-5xl font-garage uppercase"
                        >Answers: {{ userCount }}/{{ playerCount }}</span
                    >
                </div>
                <div class="flex flex-col items-center justify-center"></div>
            </div>

            <!-- Begin Desktop Footer -->
            <DesktopFooter>
                <template slot="left">
                    <div class="text-white text-2xl font-garage uppercase flex items-end h-12">
                        <p>Answers: {{ userCount }}/{{ playerCount }}</p>
                    </div>
                </template>
                <template slot="right">
                    <div class="relative"></div>
                </template>
            </DesktopFooter>
            <!-- End Desktop Footer -->
        </div>

        <CorrectAnswersPopup
            v-if="isShowCorrectAnswer && correctAnswer"
            @close="isShowCorrectAnswer = false"
            :question="question"
            :showBtnChoices="true"
            :master="true"
            :is-paid-user="true"
        />
        <ChoicesPopup v-if="isShowChoices" :question="question" @close="isShowChoices = false" />
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PollResult from '@/components/PollResult.vue'
import QuizResult from '@/components/QuizResult.vue'
import DesktopFooter from '@/components/DesktopFooter.vue'
import answer from '@/lib/answer.js'
import popup from '@/lib/popup.js'
import Background from '@/lib/background.js'
import QuizHeader from '@/components/QuizHeader.vue'
import UserCounter from '@/components/UserCounter.vue'
import BgMusicMuteBtn from '@/components/BgMusicMuteBtn.vue'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import helper from '@/lib/helper.js'
import helperMixin from '@/mixins/helper'
import CorrectAnswersPopup from '@/components/CorrectAnswersPopup.vue'
import ChoicesPopup from '@/components/ChoicesPopup.vue'

export default {
    sockets: {
        user_answered_result(data) {
            this.$store.commit('updatePlayerCount', data.users.length)

            if (this.type == 'poll') {
                this.question.answers = answer.sanitizePollAnswer(
                    data.result,
                    this.question.answers,
                    this.playingCurrentQuestionIndex
                )
                this.userCount = answer.getPollAnsweredUsers()
            }

            if (this.type == 'quiz') {
                this.quizResults = answer.sanitizeQuizAnswer(data.result, this.playingCurrentQuestionIndex)
                this.userCount = this.quizResults.length

                this.correctCount = this.quizResults.filter(e => e.result === true).length
                this.wrongCount = this.quizResults.filter(e => e.result === false).length
                this.top3 = answer.summarizeQuiz(data.result, data.users).slice(0, 3)
            }

            if (this.userCount && data.toQuizMaster) {
                var clone = this.audioDifinite.cloneNode()

                if ((this.isMuted && this.setting.masterSound.effectMusic) || !this.setting.masterSound.effectMusic) {
                    clone.muted = true
                    this.audioDifinite.muted = true
                } else {
                    clone.muted = false
                    this.audioDifinite.muted = false
                }

                if (this.setting.masterSound.effectMusic) {
                    if (helper.iOS()) {
                        this.audioDifinite.play()
                    } else {
                        clone.play()
                    }
                }
            }
        },

        master_ended_game() {
            popup.alert(
                this.$t('playlive_alert_quiz_finished'),
                function () {
                    window.location.href = '/'
                }.bind(this)
            )
        },

        master_pressed_next() {
            this.$router.push({
                name: 'live-redirect'
            })

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
        },

        master_pressed_end() {
            this.$router.push({
                name: 'live-summary'
            })

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
        },

        user_ended_game(data) {
            this.$store.commit('updatePlayerCount', data.users.length)
        },

        master_update_setting(data) {
            if (this.startLiveSection) {
                this.setting = data
                this.setSoundSetting()
            }
        },

        master_update_setting_on_start(data) {
            this.setting = data
            this.setSoundSetting()
            this.startLive()
        },

        master_receive_ping(user) {
            this.allPlayers[user.name] = new Date()
            this.lastCheckUserAt = new Date()
        },

        master_pressed_show_correct_answer() {
            this.isShowCorrectAnswer = true
            this.isShowChoices = false
        },

        master_pressed_show_answer() {
            this.isShowCorrectAnswer = false
            this.isShowChoices = true
        }
    },

    mixins: [socketConnectionMixin, helperMixin],

    components: {
        PollResult,
        QuizResult,
        DesktopFooter,
        QuizHeader,
        UserCounter,
        BgMusicMuteBtn,
        CorrectAnswersPopup,
        ChoicesPopup
    },

    created() {
        if (!document.querySelector('#dynamic-css')) {
            this.addStyleSheet(this.code)
        }

        if (!this.audioSpotify.paused) {
            this.audioSpotify.pause()
        }

        this.resetAnswerScore()

        this.$socket.emit('master_get_setting', this.code)
    },

    mounted() {
        this.$socket.emit('user_waiting_result', {
            type: this.type,
            room: this.code
        })

        if (this.type == 'poll') {
            //     this.$store.commit('updateRemoveAppPaddingX', true)
        }

        window.onpopstate = function () {
            this.$router.push({
                name: 'live-result'
            })

            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    window.location.href = '/'
                }.bind(this)
            )
        }.bind(this)

        new Background({
            color: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_color
                : this.backgroundColor,
            image: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_image
                : this.backgroundImage,
            type: this.backgroundType,
            blur: this.blur,
            darken: this.darken,
            navText: this.frontPageSetting.nav_text,
            useTheme: this.quiz.theme_name ? true : false
        })

        this.getCurrentUser()

        this.audioSpotify.oncanplay = () => {
            this.setSoundSetting()
        }

        if (!this.isLived) {
            popup.alert(this.$t('playlive_alert_secondary_screen'), () => {
                this.startLive()
                this.$store.commit('updateLiveStatus')
            })
        }
    },

    data() {
        return {
            userCount: 0,
            quizResults: [],
            isShowCorrectAnswer: true,
            correctCount: 0,
            wrongCount: 0,
            top3: [],
            setting: {},
            isSoundQuestion: false,
            startLiveSection: false,
            songXhrRequest: null,
            allMuted: true,
            isShowCorrectAnswer: false,
            isShowChoices: false
        }
    },

    methods: {
        resetAnswerScore() {
            this.question.answers.forEach(
                function (answer, index) {
                    this.question.answers[index].score = 0
                }.bind(this)
            )
        },

        imageAnswer() {
            return answer.isAllImageAnswer(this.question.answers)
        },

        setQuestionMusic() {
            // if (this.audioSpotify.currentTime > 0) {
            //     return
            // }

            const spotifyObject = this.question.spotify_track
            let cachePreviewUrl = spotifyObject.cache_preview_url
                ? spotifyObject.cache_preview_url
                : spotifyObject.preview_url

            cachePreviewUrl = cachePreviewUrl.indexOf('mp3') > -1 ? cachePreviewUrl : `${cachePreviewUrl}.mp3`

            this.songXhrRequest = helper.ajaxBlob(
                cachePreviewUrl,
                res => {
                    this.audioSpotify.src = res
                },
                () => {}
            )
        },

        startLive() {
            const haveSpotify = this.quiz.questions.filter(e => e.spotify_track).length > 0 ? true : false

            if (haveSpotify) {
                this.setSound()
            }

            this.startLiveSection = true
        },

        setSound() {
            if (this.question.spotify_track) {
                this.setQuestionMusic()
            }

            this.$store.commit('toggleQuizIsPlaySongMaster', true)
        },

        setSoundSetting() {
            const spotify = this.question.spotify_track
            const musicSetting = this.setting.masterSound.questionMusic
            const effectSetting = this.setting.masterSound.effectMusic

            this.allMuted = ((spotify && !musicSetting) || !spotify) && !effectSetting

            if (this.allMuted) {
                // Main Master unchecked all sound
                this.handleMute(this.audioSpotify, true)
                this.audioDifinite.muted = true
            } else {
                // Question music & Background music
                if (spotify) {
                    if (!musicSetting) {
                        this.handleMute(this.audioSpotify, true)
                    } else {
                        this.handleMute(this.audioSpotify, false)
                    }
                }

                // Effect sound
                if (!effectSetting) {
                    this.audioDifinite.muted = true
                } else {
                    this.audioDifinite.muted = false
                }
            }
        },

        correctAnswer: function () {
            let transformCorrectAnswerData = []
            let self = this

            self.question.answers.map((answer, index) => {
                const condition = self.question.question_type != 'sorting_list' ? answer.is_correct : true
                if (condition) {
                    transformCorrectAnswerData.push({
                        title: self.question.answers[index].title,
                        image: self.question.answers[index].image
                    })
                }
            })
            return transformCorrectAnswerData
        }
    },

    computed: {
        ...mapGetters({
            question: 'player/getCurrentQuizAppendScore',
            isEndQuiz: 'isEndQuiz',
            questionCount: 'player/getQuestionCount',
            audioDifinite: 'getDifiniteAudio',
            audioSpotify: 'getSpotifyAudio',
            confirmedPlaySound: 'getIsPlaySongMaster'
        }),

        ...mapState({
            quiz: state => state.player.quiz,
            id: state => state.player.quiz._id,
            code: state => state.player.quiz.code,
            title: state => state.player.quiz.title,
            type: state => state.player.quiz.type,
            playerCount: state => state.playerCount,
            playingCurrentQuestionIndex: state => state.player.currentQuizIndex,
            backgroundImage: state => state.player.quiz.background_image,
            blur: state => state.player.quiz.background_image_blur,
            darken: state => state.player.quiz.background_image_darken,
            backgroundColor: state => state.player.quiz.background_color,
            backgroundType: state => state.player.quiz.background_type,
            frontPageSetting: state => state.frontPageSetting,
            isMuted: state => state.isMuted,
            isLived: state => state.isLived
        })
    }
}
</script>

<style lang="scss" scoped>
.layout {
    margin-top: -1rem;
    margin-right: -1rem;
    margin-left: -1rem;

    .header-tool {
        top: 0;
        right: 0;
    }
}
</style>
